import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=e4723fc8&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=e4723fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4723fc8",
  null
  
)

export default component.exports